export const HOLIDAY_API = {
  GET_HOLIDAYS_BY_CLASS_ID: 'holiday/workingDays?ownerType={ownerType}&ownerId={ownerId}'
}

export const HOLIDAY_API_PARAMS = {
  OWNER_TYPE: '{ownerType}',
  OWNER_ID: '{ownerId}',
}